module.exports = __webpack_public_path__ + "static/media/outdent.9bf9577f.svg";